import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { Spinner } from 'reactstrap';
import Api from '../../../services/Api';
import Grid from '../Grid/Grid';
import Icon from '../Icon/Icon';
import './FileDropzone.scss';


const getIconFromMimeTypes = (mime) => {
  switch (mime) {
    case 'image/png':
    case 'image/jpeg':
    case 'image/jpg':
    case 'image/jif':
    case 'image/webp':
      return 'file-image';
    default:
      return 'file-archive';
  }
};

const FileDropzone = ({
  onFilesChanged,
  endpoint,
  allowedFiles,
  additionalPostData,
}) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: allowedFiles,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const files = uploadedFiles.map(file => (
    <div className="col-md-4 preview-item">
      <a href={file.url} target="_blank" rel="noreferrer">
        <Icon icon={getIconFromMimeTypes(file.type)} color="#000" size="3x" />
        <span>{file.name}</span>
      </a>
    </div>
  ));
  useEffect(() => {
    acceptedFiles.forEach((file) => {
      if (uploadedFiles.find(f => f.name === file.name)) {
        return;
      }
      setIsLoading(true);
      Api.uploadOneFile(endpoint, file, additionalPostData, false).then((response) => {
        if (response.status === 201 || response.status === 200) {
          const newFiles = [...uploadedFiles, response.data];
          setUploadedFiles(newFiles);
          if (onFilesChanged) {
            onFilesChanged(newFiles);
          }
          setIsLoading(false);
        }
      });
    });
  }, [acceptedFiles]);
  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
  };
  return (
    <div className="file-dropzone-container">
      <>
        {isLoading ? (
          <div className="d-flex justify-content-center mb-3">
            <Spinner />
          </div>
        ) : (
          <div {...getRootProps({ className: 'dropzone', style: baseStyle })}>
            <input {...getInputProps()} />
            <p>Drag and drop some files here, or click to select files</p>
          </div>
        )}
      </>
      <Grid>
        {files}
      </Grid>
    </div>
  );
};

FileDropzone.propTypes = {
  onFilesChanged: PropTypes.func,
  endpoint: PropTypes.string.isRequired,
  allowedFiles: PropTypes.object,
  additionalPostData: PropTypes.object,
  setIsLoading: PropTypes.func.isRequired, // or optional if not always passed

};

FileDropzone.defaultProps = {
  onFilesChanged: undefined,
  allowedFiles: {},
  additionalPostData: {},
};

export default FileDropzone;
